import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React, { forwardRef } from 'react';
import DragHandlerIcon from '@atlaskit/icon/glyph/drag-handler';
import { DragHandleButtonBase } from './drag-handle-button-base';
/**
 * A button with pre-configured styling to look like a drag handle.
 *
 * This component uses a native button because the `@atlaskit/button`
 * cancels `mouseDown` events, which prevents dragging.
 */
export var DragHandleButton = /*#__PURE__*/forwardRef(function DragHandleButton(_ref, ref) {
  var label = _ref.label,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DragHandleButtonBase, _extends({
    ref: ref
  }, buttonProps), /*#__PURE__*/React.createElement(DragHandlerIcon, {
    label: label
  }));
});